import { useProductInfo } from "@expert/contentful";
import { Flex, Modal, ScrollArea, Text } from "@mantine/core";
import React from "react";
import { GreenQuote } from "@/sales-tools/home-product/components/Icons";
import { usePartner } from "@/sdk";
import { userCache } from "@/shared-utils";
import { DisclosuresMap } from "./disclosuresMap";
import classes from "./FTCDisclosureModal.module.css";
import { InfoIcon } from "./PurpleInfo";

export const FTCDisclosureModal = ({
    opened,
    close,
    productSku,
    language,
    requiresNyDisclosures,
}: {
    opened: boolean;
    close: () => void;
    productSku: string;
    language: "en-US" | "es-US";
    requiresNyDisclosures: boolean;
}) => {
    const partner = usePartner();
    const { productInfo, error } = useProductInfo(partner, userCache.employeeId, [productSku], language);
    if (error) {
        return (
            <Text ta="center" m="xxl">
                We ran into an issue. Legal disclosures are not available right now.
            </Text>
        );
    }
    return (
        <Modal
            centered
            size="auto"
            opened={opened}
            onClose={close}
            title={`${productInfo?.[productSku].displayName}\nlegal disclosures`}
            classNames={{
                title: classes.title,
                header: classes.header,
            }}
            zIndex={"var(--mantine-priority-highest)"}
        >
            <Flex w="28.5rem">
                <Flex direction="column">
                    <ScrollArea
                        h={300}
                        classNames={{ root: classes.scrollRoot, scrollbar: classes.scrollBar }}
                        type="hover"
                    >
                        <GreenQuote />
                        <Text size="sm" mb="md">
                            <DisclosuresMap
                                requiresNyDisclosures={requiresNyDisclosures}
                                FTCDisclosures={productInfo?.[productSku].ftcDisclosures}
                            />
                        </Text>
                        <Flex className={classes.fade} h={36} w="456px" />
                    </ScrollArea>
                    <Flex bg="primary.0" className={classes.box} p="sm" direction="row" gap="md">
                        <InfoIcon width={16} height={16} />
                        <Flex>
                            <Text span c="primary.9" size="xs" fw={700}>
                                This is the customer view.{" "}
                                <Text span c="primary.9" size="xs" fw={400}>
                                    You can use this text to help answer the customer’s questions{" "}
                                </Text>
                            </Text>
                        </Flex>
                    </Flex>
                </Flex>
            </Flex>
        </Modal>
    );
};
